// PRE-ORDER BUTTON LOGIC
// Supports re-initialization for instant navigation (color swatch content swaps)
(function() {
  var currentClickHandler = null;
  
  function initPreorderLogic() {
    // Always query fresh elements
  var addToCartButton = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
  var preorderSection = document.getElementById('line-item-preorder-section');
  var preorderCheckbox = preorderSection ? preorderSection.querySelector('input[type="checkbox"]') : null;
  var productStatus = window.productStatus;
    var variantMetafields = window.variantMetafields || {};

  if (!addToCartButton || !preorderSection || !preorderCheckbox) return;

  function updateButtonAndLineItem(variant) {
      // Re-query elements to ensure we have fresh references
      var btn = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
      var section = document.getElementById('line-item-preorder-section');
      var checkbox = section ? section.querySelector('input[type="checkbox"]') : null;
      
      if (!btn || !section || !checkbox) return;
      
      var variantId = variant.id;
      var isPreOrder = (window.variantMetafields && window.variantMetafields[variantId] === "true");

      if (window.productStatus === "PRE-ORDER" || isPreOrder) {
        // PRE-ORDER: show preorder section
        // Set data-pre-order attribute so theme's toggleAddButton uses correct text
        btn.dataset.preOrder = 'true';
        btn.textContent = 'Pre-order';
        section.style.display = 'block';
        checkbox.required = true;
      
      // Update countdown when variant changes
      if (window.updateShippingCountdown) {
        window.updateShippingCountdown(variantId);
      }
      
    } else {
        // NOT PRE-ORDER: hide preorder section
        // Remove data-pre-order attribute so theme uses "Add to cart" text
        btn.dataset.preOrder = 'false';
        btn.textContent = window.variantStrings ? window.variantStrings.addToCart : 'Add to cart';
        section.style.display = 'none';
        checkbox.required = false;
      }
    }

    // Remove old click handler if exists
    if (currentClickHandler) {
      document.removeEventListener('click', currentClickHandler);
    }
    
    // Create new click handler that queries fresh elements
    currentClickHandler = function(event) {
      var btn = event.target.closest('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
      if (!btn) return;
      
      var section = document.getElementById('line-item-preorder-section');
      var checkbox = section ? section.querySelector('input[type="checkbox"]') : null;
      
      if (section && section.style.display === 'block' && checkbox && !checkbox.checked) {
        event.preventDefault();
        
        // Scroll to checkbox
        section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Add error styling
        section.classList.add('preorder-section-error');
        
        // Remove after animation
        setTimeout(function() {
          section.classList.remove('preorder-section-error');
        }, 2000);
      }
    };
    
    document.addEventListener('click', currentClickHandler, true);

    // Store the update function globally for variant:change events
    window.__updatePreorderButtonAndLineItem = updateButtonAndLineItem;
    
    // Initial state - update immediately, then watch for theme overwrites
    var initialVariantInput = document.querySelector('[name="id"]');
    if (initialVariantInput && initialVariantInput.value) {
      var btn = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
      if (btn) {
        // Update immediately (tiny delay to let inline scripts set window.variantMetafields)
        setTimeout(function() {
          updateButtonAndLineItem({ id: initialVariantInput.value });
        }, 10);
        
        // Watch for theme overwriting our change
        var initObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            // If theme changed the text or disabled state, re-apply our update
            if (mutation.type === 'childList' || mutation.type === 'characterData' || 
                (mutation.type === 'attributes' && mutation.attributeName === 'disabled')) {
              initObserver.disconnect();
              // Small delay to let theme finish, then re-apply
              setTimeout(function() {
                updateButtonAndLineItem({ id: initialVariantInput.value });
              }, 10);
            }
          });
        });
        
        initObserver.observe(btn, { 
          childList: true, 
          characterData: true, 
          attributes: true,
          attributeFilter: ['disabled']
        });
        
        // Disconnect after a short time to avoid infinite loops
        setTimeout(function() {
          initObserver.disconnect();
        }, 200);
      }
    }
  }
  
  // Listen for variant changes (uses event delegation, so works after content swap)
  document.addEventListener('variant:change', function(event) {
    var variant = event.detail.variant;
    if (variant && window.__updatePreorderButtonAndLineItem) {
      var btn = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
      if (btn) {
        // Update immediately for instant feedback
        window.__updatePreorderButtonAndLineItem(variant);
        
        // Watch for theme overwriting our change (catches theme's toggleAddButton)
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            // If theme changed the text or disabled state, re-apply our update
            if (mutation.type === 'childList' || mutation.type === 'characterData' || 
                (mutation.type === 'attributes' && mutation.attributeName === 'disabled')) {
              observer.disconnect();
              // Small delay to let theme finish, then re-apply
              setTimeout(function() {
                window.__updatePreorderButtonAndLineItem(variant);
              }, 10);
          }
        });
      });

        observer.observe(btn, { 
          childList: true, 
          characterData: true, 
          attributes: true,
          attributeFilter: ['disabled']
        });
        
        // Disconnect after a short time to avoid infinite loops
        setTimeout(function() {
          observer.disconnect();
        }, 200);
      }
    }
  });
  
  // Expose global init function for re-initialization after content swap
  window.initPreorderLogic = initPreorderLogic;
      
  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreorderLogic);
  } else {
    initPreorderLogic();
  }
  
  // Re-initialize on page:loaded (fired after content swap)
  document.addEventListener('page:loaded', function() {
    // Minimal delay to let inline scripts set window.variantMetafields
    setTimeout(initPreorderLogic, 10);
  });
})();